// Module-level error handler — registered by ErrorHandlerConnector inside ToastProvider.
// Falls back to alert() if the handler hasn't been registered yet (e.g. very early errors).
let _showError: ((msg: string) => void) | null = null;

export function registerErrorHandler(fn: (msg: string) => void) {
  _showError = fn;
}

export function onError(error: any) {
  let message = String(error);

  if (!(error instanceof Error) && error.message) {
    message = String(error.message);
  }

  if (_showError) {
    _showError(message);
  } else {
    alert(message);
  }
}
